import { render } from "./cancelAccount.vue?vue&type=template&id=01ed9965&scoped=true"
import script from "./cancelAccount.vue?vue&type=script&lang=js"
export * from "./cancelAccount.vue?vue&type=script&lang=js"

import "./cancelAccount.vue?vue&type=style&index=0&id=01ed9965&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01ed9965"]])

export default __exports__